import { render } from "./LocalRoute.vue?vue&type=template&id=70bf6fe0&scoped=true"
import script from "./LocalRoute.vue?vue&type=script&lang=js"
export * from "./LocalRoute.vue?vue&type=script&lang=js"

import "./LocalRoute.vue?vue&type=style&index=0&id=70bf6fe0&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bf6fe0"]])

export default __exports__